module.exports = __webpack_public_path__ + "img/desk4.ad00f98a.png";